module.exports = __webpack_public_path__ + "assets/img/13e59285609b0f0460d7cc34dcaa6fb3.png";